import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';
import './ListarItens.css';


class ListarItens extends Component{

    constructor(props){
        
        super(props);

        this.state = {
            show: false,
            rqtype: null,
            rqid: null,
            itens: [],
        }

    }


    showListarItens = (reqtype, reqid) => {
        this.setState({rqid: reqid});
        this.setState({rqtype: reqtype});

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), rtp: reqtype, rid: reqid })
        };

        fetch(apisettigs.endpoints.listitens, requestOptions).then(response => response.json())
        .then(data => {
            this.setState({itens: data});
            this.setState({show: true});
        });
    }


    hideListarItens = () => {
        this.setState({show: false});
        this.setState({rqtype: null});
        this.setState({rqid: null});
        this.setState({itens: []});
    }


    voltar = () => {
        if (this.state.rqtype === 'Solicitação'){
            this.hideListarItens();
            this.props.showSolic();
        }
        else if(this.state.rqtype === 'Ordem'){
            this.hideListarItens();
            this.props.showOrd();
        }
    }


    render(){

        if(this.state.show === true){
            return(
                <>
                    <div className='msgTopCont mb-3'>
                        Itens da {this.state.rqtype}
                    </div>

                    {this.state.itens.map((itens) => {
                        return(
                            <div className='container'>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg' style={{width:'3.2rem', lineHeight:'.1rem'}} >
                                        Item
                                    </div>
                                    <div className='col- align-self-center colTextItm' style={{lineHeight:'1rem'}}>
                                        {itens.itemName}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg' style={{width:'3.2rem'}} >
                                        Qtd
                                    </div>
                                    <div className='col- align-self-center colTextItm' >
                                        {itens.quantity}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg' style={{width:'3.2rem'}} >
                                        Vl.Un
                                    </div>
                                    <div className='col- align-self-center colTextItm'>
                                        {itens.unitVal}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg' style={{width:'3.2rem'}} >
                                        Total
                                    </div>
                                    <div className='col- align-self-center colTextItm '>
                                        {itens.totVal}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'3.2rem'}} >
                                        CC
                                    </div>
                                    <div className='col- align-self-center colTextItm ' >
                                        {itens.costCenter}
                                    </div>                                    
                                </div>
                                <hr className='hLn2 mt-2'/>
                            </div>
                        )
                    })}

                    <div className='container mt-4 mb-4 text-center'>
                        <button type="button" className="btn btn-outline-primary msgBtn2" onClick={this.voltar}>Voltar</button>
                    </div>

                </>
            );
        }
        else{
            return null;
        }
    }



}

export default ListarItens